import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, BrowserEvents, Classes } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});

	$('.wine-section').each(function() {

		Animations.md.min.push(() => {

			const pinned = this.querySelectorAll(':scope .image-column,:scope .millesimes-column');
			const millesimes = this.querySelectorAll(':scope .description-column .millesime');

			if(pinned) {

				pinned.forEach(pin => {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: pin,
							start: 'top top',
							end: 'max',
							pin: true,
						},
					});
				});
			}

			if(millesimes) {

				millesimes.forEach(millesime => {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: millesime,
							start: 'top 50%',
							end: 'bottom 50%',
							toggleClass: {
								className: Classes.active,
								targets: this.querySelector('[data-scroll-to="#' + millesime.attributes.id.value + '"]')
							},
						},
					});
				});
			}
		});
	});
};

$Elements.document.on(BrowserEvents.page.enter, () => initScrollAnimations());
